import { derived, writable, type Readable } from 'svelte/store';

export const loadingOverlayCount = writable(0);

export const isLoadingOverlay: Readable<boolean> = derived(loadingOverlayCount, $lc => $lc > 0);

export const abortedOverlayCount = writable(0);
